import API from "./API";

class Merchant {
  static async checkVat(data) {
    return await API.post("/merchant/users/check-vat", data);
  }

  static async register(data) {
    return await API.post("/merchant/users", data);
  }

  static async confirmAccount(data) {
    return await API.post("/merchant/users/confirm-account", data);
  }

  static async changePassword(data) {
    return await API.post("/merchant/users/change-password", data, {
      needAuth: true
    });
  }

  static async requestResetPassword(data) {
    return await API.post("/merchant/users/reset-password/request", data);
  }

  static async resetPassword(data) {
    return await API.post("/merchant/users/reset-password", data);
  }

  static async profile() {
    return await API.get("/merchant/users/profile", { needAuth: true });
  }

  static async updateProfile(data) {
    return await API.put("/merchant/users/profile", data, { needAuth: true });
  }
}

export default Merchant;
